import { render, staticRenderFns } from "./WList.vue?vue&type=template&id=6a5744e4&"
import script from "./WList.vue?vue&type=script&lang=js&"
export * from "./WList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VLayout})
